import React, { useState } from "react";
import { change, Field, FieldArray } from "redux-form";
import { useDispatch } from "react-redux";
import { components } from "react-select";
import { IconButton, Tooltip } from "@mui/material";
import { Collapse, Icon } from "antd";

import { CustomSingleSelect } from "../../../common/new-core-ui/CustomSingleSelect";
import { customTextarea } from "../../../common/customTextarea";
import { customInput } from "../../../common/custom-input";
import HazardsSection from "./HazardsSections";
import DisplayFieldValue from "../../../common/DisplayFieldValue";
import RiskField from "./RiskField";

import FormSelectStyle from "../../v2FormSelectStyle";
import styles from "../../v2Styles.module.css";

const { Panel } = Collapse;

const DisplayHasErrors = ({ meta: { touched, error } }) => {
  return touched && error ? (
    <IconButton title="This action has errors." onClick={(e) => { e.stopPropagation(); e.preventDefault(); }} className={`${styles.IconBtn} ${styles.WarningColor} p-1`} style={{ height: "fit-content" }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "16px", width: "16px" }}>
        <path fill="currentColor" d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM320 384C302.3 384 288 398.3 288 416C288 433.7 302.3 448 320 448C337.7 448 352 433.7 352 416C352 398.3 337.7 384 320 384zM320 192C301.8 192 287.3 207.5 288.6 225.7L296 329.7C296.9 342.3 307.4 352 319.9 352C332.5 352 342.9 342.3 343.8 329.7L351.2 225.7C352.5 207.5 338.1 192 319.8 192z" />
      </svg>
    </IconButton>
  ) : null
}


export default function ActivityActionsSection({ fields, consequences, likelihoods, loading, loadingData, meta: { error }, disabled, formName }) {
  const [activeKey, setActiveKey] = useState("action_name_0");

  const dispatch = useDispatch();
  const onNewAction = () => {
    const newKey = fields.length;
    fields.push({ action_name: "", hazards: [{ hazard_name: "", consequences: [{ id: Date.now(), isNew: true }] }] });
    setActiveKey(`action_name_${newKey}`);
  }

  const onMoveRow = (from, to) => {
    if (from !== to) {
      fields.move(from, to);
      dispatch(change(formName, "_v", Date.now()))
    }
  }

  return (
    <div className="">
      {error ? <div className="error mt-2">{error}</div> : ""}
      <Collapse style={{ background: "#fff" }} bordered={false} activeKey={activeKey} onChange={(v) => { setActiveKey(v); }} accordion className="v2-collapse swms-masters-action-collapse" expandIconPosition="right" expandIcon={({ isActive }) => (
        <Icon
          style={{ color: "#2f1f41" }}
          type="caret-right"
          rotate={isActive ? 90 : 0}
        />
      )}>
        {fields.map((member, index) => (
          <Panel style={{ border: '0px !important', marginTop: index === 0 ? "0px" : "10px" }}
            header={
              <div style={{ padding: "8px", color: "#000", display: "flex", alignItems: "center", justifyContent: "space-between", marginRight: "30px" }}>
                <Field name={`${member}.action_name`} component={DisplayFieldValue} defaultValue={`${index + 1}. New Action`} />
                <div className="d-flex align-items-center justify-content-end" style={{ gap: "5px" }}>
                  <Field name={`${member}.hasErrors`} component={DisplayHasErrors} />
                  <div className="d-flex" style={{}}>
                    <Tooltip title="Move action up">
                      <span>
                        <IconButton disabled={loading || disabled || fields.length <= 1 || index === 0} onClick={(e) => { e.stopPropagation(); e.preventDefault(); onMoveRow(index, index - 1) }} className={`${styles.IconBtn} ${styles.SecondaryColor} p-1`} sx={{ height: "fit-content", paddingRight: "0px !important" }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "16px", width: "16px" }}>
                            <path fill="currentColor" d="M297.4 201.4C309.9 188.9 330.2 188.9 342.7 201.4L502.7 361.4C515.2 373.9 515.2 394.2 502.7 406.7C490.2 419.2 469.9 419.2 457.4 406.7L320 269.3L182.6 406.6C170.1 419.1 149.8 419.1 137.3 406.6C124.8 394.1 124.8 373.8 137.3 361.3L297.3 201.3z" />
                          </svg>
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Move action down">
                      <span>
                        <IconButton disabled={loading || disabled || fields.length <= 1 || index === fields.length - 1} onClick={(e) => { e.stopPropagation(); e.preventDefault(); onMoveRow(index, index + 1) }} className={`${styles.IconBtn} ${styles.SecondaryColor} p-1`} style={{ height: "fit-content" }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "16px", width: "16px" }}>
                            <path fill="currentColor" d="M297.4 438.6C309.9 451.1 330.2 451.1 342.7 438.6L502.7 278.6C515.2 266.1 515.2 245.8 502.7 233.3C490.2 220.8 469.9 220.8 457.4 233.3L320 370.7L182.6 233.4C170.1 220.9 149.8 220.9 137.3 233.4C124.8 245.9 124.8 266.2 137.3 278.7L297.3 438.7z" />
                          </svg>
                        </IconButton>
                      </span>
                    </Tooltip>
                  </div>
                  <IconButton disabled={loading || disabled || fields.length <= 1} onClick={(e) => { e.stopPropagation(); e.preventDefault(); fields.remove(index) }} className={`${styles.IconBtn} ${styles.DangerColor} p-1`} style={{ height: "fit-content" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "16px", width: "16px" }}>
                      <path fill="currentColor" d="M232.7 69.9L224 96L128 96C110.3 96 96 110.3 96 128C96 145.7 110.3 160 128 160L512 160C529.7 160 544 145.7 544 128C544 110.3 529.7 96 512 96L416 96L407.3 69.9C402.9 56.8 390.7 48 376.9 48L263.1 48C249.3 48 237.1 56.8 232.7 69.9zM512 208L128 208L149.1 531.1C150.7 556.4 171.7 576 197 576L443 576C468.3 576 489.3 556.4 490.9 531.1L512 208z" />
                    </svg>
                  </IconButton>
                </div>
              </div>
            }
            key={`action_name_${index}`}
            className={`custom-swms-category-header ${styles.PanelCard}`}>
            <>
              <div className="container-fluid px-0">
                <div className="row align-center">
                  <div className="col-8">
                    <div>
                      <div className={styles.Label}>Action Name</div>
                      <Field disabled={loading || disabled} name={`${member}.action_name`} component={customInput} className={styles.TextField} />
                    </div>
                  </div>
                  <div className="col-4">
                  </div>
                </div>
              </div>
              <div className="border rounded mt-3">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-5 border-right">
                      <FieldArray
                        name={`${member}.hazards`}
                        loadingData={loadingData}
                        consequences={consequences}
                        likelihoods={likelihoods}
                        formName={formName}
                        loading={loading}
                        disabled={disabled}
                        actIndex={index}
                        component={HazardsSection}
                      />
                    </div>
                    <div className="col-7">
                      <div className="container-fluid px-0 my-2">
                        <div className="row">
                          <div className="col-3">
                            <div className={styles.Label}>Before Controls</div>
                            <div>
                              <div className={styles.Label}>Likelihood</div>
                              <Field
                                name={`${member}.before_likelihood`}
                                component={CustomSingleSelect}
                                options={likelihoods}
                                styles={FormSelectStyle}
                                otherProps={{
                                  isDisabled: loading || disabled,
                                  isLoading: loadingData,
                                  components: { dropdownIndicator: <components.DownChevron /> },
                                }}
                              />
                            </div>
                            <div>
                              <div className={styles.Label}>Consequence</div>
                              <Field
                                name={`${member}.before_consequence`}
                                component={CustomSingleSelect}
                                options={consequences}
                                otherProps={{
                                  isDisabled: loading || disabled,
                                  isLoading: loadingData,
                                  components: { dropdownIndicator: <components.DownChevron /> },
                                }}
                                styles={FormSelectStyle}
                              />
                            </div>
                            <div>
                              <div className={styles.Label}>Initial Risk</div>
                              <Field
                                name={`${member}.initialRisk`}
                                formName={formName}
                                likelihood={`${member}.before_likelihood`}
                                consequence={`${member}.before_consequence`}
                                component={RiskField} />
                            </div>
                          </div>
                          <div className="col-4">
                            <div>
                              <div className={styles.Label}>Control Measures</div>
                              <Field
                                className={`${styles.TextArea} ${styles.AutoHeight} ${styles.Rows4}`}
                                component={customTextarea}
                                disabled={loading || disabled}
                                rows={4}
                                name={`${member}.control_measures`}
                              />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className={styles.Label}>After Controls</div>
                            <div>
                              <div className={styles.Label}>Likelihood</div>
                              <Field
                                name={`${member}.after_likelihood`}
                                component={CustomSingleSelect}
                                options={likelihoods}
                                styles={FormSelectStyle}
                                otherProps={{
                                  isDisabled: loading || disabled,
                                  isLoading: loadingData,
                                  components: { dropdownIndicator: <components.DownChevron /> },
                                }}
                              />
                            </div>
                            <div>
                              <div className={styles.Label}>Consequence</div>
                              <Field
                                name={`${member}.after_consequence`}
                                component={CustomSingleSelect}
                                options={consequences}
                                otherProps={{
                                  isDisabled: loading || disabled,
                                  isLoading: loadingData,
                                  components: { dropdownIndicator: <components.DownChevron /> },
                                }}
                                styles={FormSelectStyle}
                              />
                            </div>
                            <div>
                              <div className={styles.Label}>Residual Risk</div>
                              <Field
                                name={`${member}.residualRisk`}
                                likelihood={`${member}.after_likelihood`}
                                formName={formName}
                                consequence={`${member}.after_consequence`}
                                component={RiskField} />
                            </div>
                          </div>
                          <div className="col-2">
                            <div>
                              <div className={styles.Label}>Action By (PIC)</div>
                              <Field
                                name={`${member}.persons_in_control`}
                                className={styles.TextField}
                                disabled={loading || disabled}
                                component={customInput}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </Panel>
        ))}
      </Collapse>
      <button className={`${styles.PrimaryButton} mt-2`} type="button" disabled={loading || disabled} onClick={() => onNewAction()}>
        Add Action
      </button>
    </div>
  )
}